import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Order } from 'src/app/models';
import { DataClientService } from 'src/app/services/data-client.service';

@Component({
  selector: 'app-local-order-list',
  templateUrl: './local-order-list.component.html',
  styleUrls: ['./local-order-list.component.scss']
})
export class LocalOrderListComponent implements OnInit {

  @Input() allOrders$: Observable<Order[]>
  @Input() currentOrderId: string = ''

  constructor(
    private router: Router,
    private db: DataClientService
  ) { }

  ngOnInit(): void {
  }

  goToOrder(ord:Order) {
    this.router.navigateByUrl(`/in/${ord.restId}/${ord.tableId}/${ord._id}`)
  }

  async deleteOrder(ord:Order) {
    await this.db.deleteOrder(ord)
  }

}